module.exports = __webpack_public_path__ + "img/lock_text_b.ef53ffeb.svg";